"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
const NoItemMessage = ({ message }) => ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: 'no-item-message disabled pointer-events-none' }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ role: 'button', href: 'any' }, { children: (0, jsx_runtime_1.jsx)("i", { children: message }) })) })));
exports.default = NoItemMessage;
